import columns from '../../../../react-table/helpers/columns';
import TableDefinitions from '../../../../../common/TableDefinitions';

export const ediTypeFormatting = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    if (rowInfo.row.dailyRouteLeadingCountStatus.includes('EDI')) {
      className = 'bg-green';
    }
  }
  return {
    className,
  };
};

export const rfidTypeFormatting = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    if (rowInfo.row.dailyRouteLeadingCountStatus.includes('RFID')) {
      className = 'bg-green';
    }
  }
  return {
    className,
  };
};

export function callUseMax(rowInfo) {
  return rowInfo && rowInfo.row.dailyRouteLeadingCountStatus.includes('MAX') ? {
    path: '/edi-rfid-audit-request-report',
    tableId: TableDefinitions.EDI_RFID_AUDIT_REQUEST_EXECUTION_REPORT.id,
    text: 'Use EDI',
  } : {
    path: '/edi-rfid-audit-request-report',
    tableId: TableDefinitions.EDI_RFID_AUDIT_REQUEST_EXECUTION_REPORT.id,
    text: 'Use Max',
  };
}

export default (data) => {
  const {
    FilteredDateColumn,
    FilteredPercentageColumn,
    FilteredNumberColumn,
    FilteredTextColumn,
    NavigationColumn,
    EditButtonColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredNumberColumn('Id', 'assetRouteId').withShow(false),
        new FilteredDateColumn('Date', 'date'),
        new FilteredTextColumn('Outbound Operator', 'outboundOperator'),
        new FilteredTextColumn('Outbound IMPC', 'outboundImpc'),
        new FilteredTextColumn('Inbound Operator', 'inboundOperator'),
        new FilteredTextColumn('Inbound IMPC', 'inboundImpc'),
        new FilteredNumberColumn('Generated From PREDES', 'generatedFromPredes'),
        new FilteredNumberColumn('Manual PRE-ADVISE', 'manualPreAdvice'),
        new FilteredNumberColumn('Central Repat', 'centralRepatriation'),
        new FilteredNumberColumn('Total', 'total').withGetProps(ediTypeFormatting),
        new FilteredNumberColumn('RFID Base Sleeve Movement Count', 'rfidBaseSleeve').withGetProps(rfidTypeFormatting),
        new FilteredNumberColumn('RFID - EDI', 'rfidEdi'),
        new FilteredPercentageColumn('(RFID - EDI)/EDI %', 'rfidEdiRate'),
        new FilteredTextColumn('Daily route leading count status', 'dailyRouteLeadingCountStatus'),
        new NavigationColumn(new EditButtonColumn('', 'dailyRouteLeadingCountStatus').withWidth(127.283), callUseMax),
      ],
    },
  ];
};
